import { gql } from '@apollo/client';

export default gql`
  mutation CreateBuyer($record: CreateOneBuyerInput!) {
    createBuyer(record: $record) {
      recordId
    }
  }
`;
